import * as React from "react";
import {CSSProperties, ReactNode} from "react";
import {Dialog, DialogProps} from "shared/controls/Dialogs/core/Dialog";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

export abstract class DynamicDialog<P extends DynamicDialogProps=any,S extends DynamicDialogState=any> extends React.Component<P, S>{
    public OnDispose:()=>void=null;

    private _sendResult:(result)=>void=null;

    public abstract SubRenderer(): React.ReactNode;

    public abstract GetAdditionalProperties(): DialogProps;

    render():ReactNode {
        let props=this.GetAdditionalProperties();
        return (
        <Dialog  OnClose={()=>this.SendResult(null)} AfterOnClose={()=>{this.OnDispose()}} IsOpen={this.state.IsOpen} {...props} >
            {this.SubRenderer()}
        </Dialog>
        );
    }

    public SendResult(args:any)
    {
        this._sendResult(args);
        this.setState({
            IsOpen:false
        });
    }

}

export class DynamicDialogProps{

}

export class DynamicDialogState {
    IsOpen:boolean;
}